export function timeframesGetFromNow(timeframe: string): {
  before: number;
  after: number;
} {
  const now = new Date();
  now.setHours(0);
  now.setMinutes(0);
  now.setSeconds(0);
  now.setMilliseconds(0);

  const endOfDay = new Date(now);
  endOfDay.setHours(23);
  endOfDay.setMinutes(59);
  endOfDay.setSeconds(59);
  endOfDay.setMilliseconds(999);

  const before = endOfDay.getTime();
  let after: number;

  switch (timeframe) {
    case "4H":
      after = now.setHours(now.getHours() - 4);
      break;
    case "12H":
      after = now.setHours(now.getHours() - 12);
      break;
    case "1D":
      after = now.setDate(now.getDate() - 1);
      break;
    case "1W":
      after = now.setDate(now.getDate() - 7);
      break;
    case "1M":
      after = now.setMonth(now.getMonth() - 1);
      break;
    case "3M":
      after = now.setMonth(now.getMonth() - 3);
      break;
    case "1Y":
      after = now.setFullYear(now.getFullYear() - 1);
      break;
    case "YTD": {
      const startOfYear = new Date(now);
      startOfYear.setMonth(0);
      startOfYear.setDate(1);
      after = startOfYear.getTime();
      break;
    }
    default:
      after = now.getTime();
      break;
  }

  return {
    before,
    after,
  };
}
